<template>
    <div>
        <EmployeeRemainingLeaveCount />
        <EmployeeLeaveSummary />
    </div>
</template>

<style scoped lang="scss"></style>

<script setup>
import EmployeeLeaveSummary from '@/components/Attendance/Dev/EmployeeLeaveSummary.vue';
import EmployeeRemainingLeaveCount from '@/components/Attendance/Dev/services/EmployeeRemainingLeaveCount.vue';
export default {
    components: { EmployeeLeaveSummary, EmployeeRemainingLeaveCount },
};
</script>
